"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var UserDocument = function UserDocument(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#ffffff' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 13"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.262 6.5c.624 0 1.084-.46 1.084-1.083 0-.624-.46-1.084-1.084-1.084-.623 0-1.083.46-1.083 1.084 0 .623.46 1.083 1.083 1.083Z",
    fill: color
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.833 2.167H2.167c-.598 0-1.084.455-1.084 1.015v6.636c0 .56.486 1.015 1.084 1.015h8.666c.598 0 1.084-.455 1.084-1.015V3.182c0-.56-.486-1.015-1.084-1.015ZM11 10H2V3h9v7Z",
    fill: color
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.583 4.875H9.75v1.083H7.583V4.875Zm.542 2.167H9.75v1.083H8.125V7.042Zm-.85 1.373c0-.744-.908-1.509-2.013-1.509-1.104 0-2.012.765-2.012 1.51v.25h4.025v-.25Z",
    fill: color
  }));
};
var _default = exports["default"] = UserDocument;